/**
 * Special distributor-filter options for the UPB/MFC viewer.
 *
 * In addition to "All Distributors" and the searchable per-distributor list, the
 * dropdown offers a few Influence-campaign distributor groups. Selecting one
 * scopes the viewer's TAM to every distributor partner carrying the matching
 * `third_party` tag (resolved server-side), letting internal users see the TAM
 * for an Influence campaign at the category or MFC level.
 *
 * `tag` must match the GlobalVendor `third_party` tag the backend filters on
 * (see app/lib/constants/constants.py).
 */
export const DISTRIBUTOR_TAG_FILTERS = [
  { tag: 'instacartAdsEnabled', label: 'All Instacart Ad DPs' },
  { tag: 'manufacturerRebatesEnabled', label: 'All Influence Rebate DPs' },
];

export default DISTRIBUTOR_TAG_FILTERS;
